import React, {useState} from "react";
import {
    Box,
    TextField,
    ToggleButtonGroup,
    ToggleButton, Autocomplete
} from "@mui/material";
import {SearchOutlined} from "@mui/icons-material";
import Stack from "@mui/material/Stack";
import {GanttChart} from "@/pages/Analyze/Kanban/GanttChart";
import {PlanBoard} from "@/pages/Analyze/Kanban/PlanBoard";
import {TaskBoard} from "@/pages/Analyze/Kanban/TaskBoard";

const KanbanPage = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [tab, setTab] = useState<number>(1)

    return (
        <Box sx={{width: "100%", maxWidth: {sm: "100%", md: "1700px"},}}>
            <Stack mb={2} direction={'row'} alignContent={'center'} alignItems={'center'
            } justifyContent={'space-between'} sx={{borderColor: 'divider'}}>
                <ToggleButtonGroup
                    color="primary"
                    value={tab}
                    onChange={(event, value: number) => value && setTab(value)}
                    size={'small'}
                    sx={{
                        height: '40px',
                        boxShadow: 'none', "& .MuiButtonBase": {
                            padding: '4px 12px',
                        },
                    }}
                    exclusive
                    aria-label="Platform"
                >
                    <ToggleButton size={'large'} value={1}>目标计划</ToggleButton>
                    <ToggleButton size={'large'} value={2}>任务明细</ToggleButton>
                    <ToggleButton size={'large'} value={3}>甘特图</ToggleButton>
                </ToggleButtonGroup>
                <Stack direction={'row'} spacing={2}>
                    <Autocomplete
                        options={[]}
                        fullWidth
                        sx={{width: 220}}
                        renderInput={(params) => (
                            <TextField
                                variant="outlined"
                                placeholder={"任务状态"} {...params} />
                        )}
                    />
                    <TextField
                        placeholder="搜索任务..."
                        value={searchQuery}
                        sx={{width: 220}}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: <SearchOutlined fontSize={'small'} color={'action'}/>
                            }
                        }}
                    />
                </Stack>

            </Stack>
            {/*maxHeight: "calc(100vh - 136px)",*/}
            {tab == 1 && <PlanBoard/>}
            {tab == 2 && <TaskBoard/>}
            {tab == 3 && <GanttChart/>}

            {/*</Card>*/}
        </Box>
    );
};

export default KanbanPage;